import { AxiosResponse } from 'axios'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { confirmPasswordReset } from 'firebase/auth'

import { api } from '@/lib/axios'
import { getFirebaseAuth } from '@/lib/firebase'
import { AuthUser } from '@/types/auth.types'
import { MerchantType } from '@/types/merchant.types'
import { UserImage } from '@/types/orders.types'

export type LoginAuthProps = { email: string; password: string }
export interface ForgotPasswordRequest {
  code: string
  password: string
}

const login = ({ email, password }: LoginAuthProps) => {
  return signInWithEmailAndPassword(getFirebaseAuth(), email, password)
}

const logout = (uuid: string) => {
  return api.post<{ message: string }>(`/users/${uuid}/signOut`)
}

const forgotPassword = (
  email: string
): Promise<AxiosResponse<{ data: { status: number } }>> => {
  return api.get<{ data: { status: number } }>(`/users/partner/${email}/reset`)
}

const getUser = async (uuid: string) => {
  const { data } = await api.get<AuthUser>(`/users/${uuid}`)
  return data
}

const getConsumerProfilePicture = (
  uuid: string | undefined
): Promise<AxiosResponse<UserImage>> => {
  return api.get<UserImage>(`/users/${uuid}/picture`)
}

const getMerchant = (id: string): Promise<AxiosResponse<MerchantType>> => {
  return api.get<MerchantType>(`/merchants/${id}`)
}

const getMultipleMerchants = async (ids: Array<string>) => {
  if (ids.length > 0) {
    const { data } = await api.get<MerchantType[]>(
      `/multiple-merchants?merchants=${ids.join(',')}`
    )
    return data
  }

  return undefined
}

async function newPassword({ code, password }: ForgotPasswordRequest) {
  return await confirmPasswordReset(getFirebaseAuth(), code, password)
}

export default {
  login,
  getUser,
  getMerchant,
  getMultipleMerchants,
  logout,
  forgotPassword,
  newPassword,
  getConsumerProfilePicture,
}
